<template lang="html">

  <section class="call_to_action">   
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="call_to_action_filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <p class="card-text">Filters</p>
              <div class="row">
                <div class="col-lg-3">Code:</div><input type="text" class="col-lg-3" v-model="codeFilter" placeholder="Code"/>
                <div class="col-lg-3">Label:</div><input type="text" class="col-lg-3" v-model="labelFilter" placeholder="Label"/>
              </div>
              <b-button variant="primary" v-b-toggle.call_to_action_filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-3">
              <h4 class="card-title">Call To Action</h4>
              <p class="card-description">
                {{curModel}} - {{getCurModel7DigitsCode}} - {{getLanguageLabel}}
              </p>
            </div>
            <div class="col-lg-4">
             <b-tooltip target="tooltip-target-1" triggers="hover">                    
              </b-tooltip>
              <div class="col-lg-12 row">
                <b-pagination
                  align="fill"
                  limit="6"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls=""
                  class="col-lg-9"
                ></b-pagination>
                <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-3">
                  <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
              </div>
            </div>
            <div class="col-lg-5">
              <span class="float-right">
                <b-button variant="primary mr-1" @click="refreshTable"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-toggle.call_to_action_filters v-if="false"><i class="mdi mdi-filter"></i></b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-new @click="btnNew"><i class="mdi mdi-plus"></i>New</b-button>
                <b-button variant="primary mr-1" v-if="false"><i class="mdi mdi-file-export"></i>Export</b-button>
                <b-button variant="primary" v-if="false"><i class="mdi mdi-file-import"></i>Import</b-button>
              </span>
            </div>
            <div id="overflow_nav_buttons">
              <span id="left_b" class="ovf_nav_btn_l" @click="scrollXPage('#table',0)">
                <i class="mdi mdi-chevron-double-left"></i>
              </span>
              <span id="right_b" class="ovf_nav_btn_r" @click="scrollXPage('#table',1)">
                <i class="mdi mdi-chevron-double-right"></i>
              </span>
            </div>
            <b-table ref="call_to_action_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="fields"
              :per-page="perPage"
              :current-page="1"
              primary-key="code"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            >
              <!-- A custom formatted column -->
              <template v-slot:cell(buttons)="data" lang="html">
                <b-row>
                  <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" @click="curItem=data.item; getCountries();">
                    <i class="mdi mdi-pencil"></i>
                  </b-button>
                  <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="danger" @click="deleteItem(data.item)">
                    <i class="mdi mdi-delete"></i>
                  </b-button>
                </b-row>
              </template>
            </b-table>
            <b-modal id="modal-edit" title="Edit" v-if="curItem" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
                <b-container fluid>
                  <ul class="nav nav-tabs" id="editCountryTab" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link" :class="{ 'active show': isActive('textFields') }" id="textFieldstab" @click.prevent="setActive('textFields')" data-toggle="tab" href="#textFields" role="tab" aria-controls="textFields" aria-selected="true">CTA Configuration</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" :class="{ 'active show': isActive('countryFields') }" id="countryFieldstab" @click.prevent="setActive('countryFields')"  data-toggle="tab" href="#countryFields" role="tab" aria-controls="countryFields" aria-selected="false">Countries</a>
                    </li>                    
                  </ul>
                  <hr>
                  <div class="col-lg-12">
                  <div class="tab-pane fade col-lg-12" role="tabpanel" aria-labelledby="textFieldstab" :class="{ 'active show': isActive('textFields') }" id="textFields">
                    
                    <div class="col-lg-12">      
                       <b-row>
                        <div class="col-lg-3">Code*:</div><input type="text" class="col-lg-3" placeholder="Code" v-model="curItem.code" />
                        <div class="col-lg-3">LabelCode*:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="curItem.labelCode"/>
                      </b-row>
                      <hr>
                      <b-row>
                        <div class="col-lg-3">Link Code:</div><input type="text" class="col-lg-3" placeholder="Link Code" v-model="curItem.linkCode"/>
                        <div class="col-lg-3">St key:</div><input type="text" class="col-lg-3" placeholder="StKey" v-model="curItem.stKey"/>
                      </b-row>
                      <hr>
                      <b-row>
                        <div class="col-lg-3">Adobe Key:</div><input type="text" class="col-lg-3" placeholder="Adoby Key" v-model="curItem.adobeKey" />
                        <div class="col-lg-3">Icon Key:</div><input type="text" class="col-lg-3" placeholder="Icon Key" v-model="curItem.iconKey"/>
                      </b-row>
                      <hr>
                      <b-row>
                        <div class="col-lg-3">Description Key:</div><input type="text" class="col-lg-3" placeholder="Description Key" v-model="curItem.descriptionKey" />
                        <div class="col-lg-3">Sort Number:</div><input type="text" class="col-lg-3" placeholder="Sort Number" v-model="curItem.sortNumber"/>
                      </b-row>
                    </div>                    
                  </div>
                  <div class="tab-pane fade col-lg-10" role="tabpanel" aria-labelledby="countryFieldstab" :class="{ 'active show': isActive('countryFields') }" id="countryFields">
                    <b-table ref="cca_table"
                      id="cca_table_" 
                      striped 
                      hover 
                      responsive 
                      :items="(countryCtaListMerged && countryCtaListMerged.length) ? countryCtaListMerged : []" 
                      :fields="country_fields"
                      :per-page="(countryCtaListMerged && countryCtaListMerged.length) ? countryCtaListMerged.length : perPage"
                      :current-page="1"
                      primary-key="countryId"
                      no-local-sorting
                      no-provider-paging
                      sort-icon-left
                    > <!-- A custom formatted column -->                                
                    <template v-slot:cell(cta_checkbox)="data" lang="html">
                      <b-row>
                      <h4 class="panel-title" style="margin:auto;">
                        <a role="button" data-toggle="collapse" href="javascript:void(0);" @click="curItemCcta=data.item" aria-expanded="true" aria-controls="collapseOne">
                          <b-button v-if="data.item.enable" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover title="Disable CountryCta" @click="curItemCcta=data.item; toggleCountryCtaStatus(data.item,0)">
                            <i class="mdi mdi-check-outline  btn-outline-success" style="display: block;"></i>
                          </b-button> 
                          <b-button v-else class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="danger" v-b-tooltip.hover title="Enable CountryCta" @click="curItemCcta=data.item; toggleCountryCtaStatus(data.item,1)">
                            <i class="mdi mdi-close-outline  btn-outline-secondary" style="display: block;"></i>
                          </b-button>                                      
                        </a>
                      </h4>
                      </b-row>
                    </template>
                    <!-- A custom formatted column -->                                
                    <template v-slot:cell(cta_relevant_checkbox)="data" lang="html">
                      <b-row>
                      <h4 class="panel-title" style="margin:auto;">
                        <a role="button" data-toggle="collapse" href="javascript:void(0);" @click="curItemCcta=data.item" aria-expanded="true" aria-controls="collapseOne">
                          <b-button v-if="data.item.relevant" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover title="Relevant CountryCta" @click="curItemCcta=data.item; toggleCountryCtaRelevant(data.item,0)">
                            <i class="mdi mdi-check-outline  btn-outline-success" style="display: block;"></i>
                          </b-button> 
                          <b-button v-else class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="danger" v-b-tooltip.hover title="Relevant CountryCta" @click="curItemCcta=data.item; toggleCountryCtaRelevant(data.item,1)">
                            <i class="mdi mdi-close-outline  btn-outline-secondary" style="display: block;"></i>
                          </b-button>                                      
                        </a>
                      </h4>
                      </b-row>
                    </template>
                    <template v-slot:cell(model_enable)="data" lang="html">
                      <b-row>                                    
                        <input type="text" class="col-lg-12" v-model="data.item.modelEnableRegexp" placeholder="modelEnableRegexp"/>
                      </b-row>
                    </template>
                    <template v-slot:cell(model_disable)="data" lang="html">
                      <b-row>
                        <input type="text" class="col-lg-12" v-model="data.item.modelDisableRegexp" placeholder="modelDisableRegexp"/>
                      </b-row>
                    </template>
                    <template v-slot:cell(save_button)="data" lang="html">
                      <b-row>
                          <h4 class="panel-title" style="margin:auto;">                                        
                          <a role="button" data-toggle="collapse" href="javascript:void(0);"   @click="curItemCcta=data.item" aria-expanded="true" aria-controls="collapseOne">
                          <b-button variant="primary mr-1" @click="askSaveCountryCta(data.item)"> SAVE <i class="mdi mdi-check-outline"></i></b-button>
                          </a>
                        </h4>
                      </b-row>
                    </template>
                  </b-table>             
                </div>
                </div>   
              </b-container>              
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="saveCurItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
             <b-modal id="modal-new" title="New Call To Action"  size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                  <hr>
                  <b-row>
                  <div class="col-lg-3">Code*:</div><input type="text" class="col-lg-3" placeholder="Code" v-model="newItem.code" />
                  <div class="col-lg-3">LabelCode*:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="newItem.labelCode"/>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">Link Code:</div><input type="text" class="col-lg-3" placeholder="Link Code" v-model="newItem.linkCode"/>
                  <div class="col-lg-3">St key:</div><input type="text" class="col-lg-3" placeholder="StKey" v-model="newItem.stKey"/>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">Adobe Key:</div><input type="text" class="col-lg-3" placeholder="Adoby Key" v-model="newItem.adobeKey" />
                  <div class="col-lg-3">Icon Key:</div><input type="text" class="col-lg-3" placeholder="Icon Key" v-model="newItem.iconKey"/>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">Description Key:</div><input type="text" class="col-lg-3" placeholder="Description Key" v-model="newItem.descriptionKey" />
                  <div class="col-lg-3">Sort Number:</div><input type="text" class="col-lg-3" placeholder="Sort Number" v-model="newItem.sortNumber"/>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="createItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<style>
.expandableContent {
  transition: 300ms ease-out;
}
.closed {
  height: 0vh !important;
}
.table td,
.table th {
  max-width: 25vw;
}

li.nav-item.active > a {
  color: #fff !important;
  text-shadow: 2px 2px 4px rgba(100, 100, 100, 0.5);
}
</style>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
 const FileDownload = require('js-file-download');
export default {
  name: 'call_to_action',
  methods: {
    expandItem(element){
      //console.log(element)
      this.accordionManager()
    },
    accordionManager () {
      document.querySelectorAll('tr[role=row][data-pk]').forEach(el=>{     
        var tr = document.createElement('tr')
            tr.className = 'expandableContent closed';
        var td = document.createElement('td')
            td.setAttribute('colspan',6);
            td.style.backgroundColor = 'yellow';  

            tr.appendChild(td);
            el.parentNode.appendChild(tr);
            el.parentNode.insertBefore(el,tr)
      })
    },
    deleteItem(item) {
      this.$bvModal.msgBoxConfirm('Vuoi veramente cancellare '+item.code+'?', {
        title: 'Elimina',
        okVariant: 'danger',
        okTitle: 'Elimina',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (value){
          this.setSpinnerStatus(true);    
          this.axios
          .delete('/ccb/auth/fe/callToAction/' + item.id ,this.authHeader)
          .then(response => {
            this.setSpinnerStatus(false);
            this.$bvModal.msgBoxOk(response.data.message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            })
            .then(value => {
              this.refreshTable();
              this.curItem=null;
            })
          }) 
          .catch(error => {
              this.$bvModal.msgBoxOk(error.message, {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
          })
          }).finally(e=>{
              this.setSpinnerStatus(false);
          })
        }
      })
     
    },
    saveCurItem(curItem) {
      this.setSpinnerStatus(true);
      window.curr = curItem
      var intLabObj = curItem        
      this.axios
        .put('/ccb/auth/fe/callToAction/' + curItem.id, intLabObj ,this.authHeader)
        .then(response => { 
          if(response.status == 200) {            
            this.$bvModal.msgBoxOk(response.data.message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            })
            .then(value => {
              this.refreshTable();
            })
          }
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        }).finally(e=>{
          this.setSpinnerStatus(false);
          this.$bvModal.hide('modal-edit');
        })
    }, 
    askSaveCountryCta(item) {     
      this.$bvModal.msgBoxConfirm('Vuoi Salvare?', {
        title: 'Cambio Stato CountryCta',
        okVariant: 'danger',
        okTitle: 'Procedi',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value){
          this.saveCountryCta(item);         
        }
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      })
    },
    toggleCountryCtaStatus(item,visibilityValue) {//fare la stessa cosa per relevant
      //console.log(item);
      var stato = (!visibilityValue) ? 'disattivare' : 'attivare'
      this.$bvModal.msgBoxConfirm('Vuoi '+stato+'?', {
        title: 'Cambio Stato CountryCta',
        okVariant: 'danger',
        okTitle: 'Procedi',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value){
          item.enable=visibilityValue;
          this.saveCountryCta(item);         
        }
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      })
    },
    toggleCountryCtaRelevant(item,visibilityValue) {//fare la stessa cosa per relevant
      //console.log(item);
      var stato = (!visibilityValue) ? 'disattivare' : 'attivare'
      this.$bvModal.msgBoxConfirm('Vuoi '+stato+'?', {
        title: 'Cambio Stato Relevant CountryCta',
        okVariant: 'danger',
        okTitle: 'Procedi',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value){
          item.relevant=visibilityValue;
          this.saveCountryCta(item);         
        }
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      })
    },
    saveCountryCta(ccta) {
      this.setSpinnerStatus(true);
      ccta.callToAction = this.curItem;
      window.curr = ccta
      var intLabObj = ccta
      if (ccta.id) {     
        this.axios
          .put('/ccb/auth/fe/countryCallToAction/' + ccta.id, intLabObj ,this.authHeader)
          .then(response => {
            if(response.status == 200) {            
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
              .then(value => {
                this.getCountryCta();
                this.refreshTable();
              })
            }
          }
        )
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        })
        .finally(e=>{
          this.setSpinnerStatus(false);
        })
      }
      else {
        this.axios
          .post('/ccb/auth/fe/countryCallToAction', intLabObj ,this.authHeader)
          .then(response => {
            if(response.status == 200) {            
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
              .then(value => {
                this.getCountryCta();
                this.refreshTable();
              })
            }
          }
        )
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        })
        .finally(e=>{
          this.setSpinnerStatus(false);
        })
      }
    },
    createItem() {
      var intLabObj = this.newItem     
      if((intLabObj.code==null || intLabObj.labelCode==null) || (intLabObj.code.trim()=="" || intLabObj.labelCode.trim()=="")) {
        this.$bvModal.msgBoxOk("Inserisci tutti i campi obbligatori", {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      }else{  
        this.setSpinnerStatus(true);  
        this.axios
        .post('/ccb/auth/fe/callToAction', intLabObj, this.authHeader)
          .then(response => {
            if(response.status == 200) {
            this.$bvModal.msgBoxOk(response.data.message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            })
            .then(value => {
                this.refreshTable();
              })
            }
          })
          .catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
          })
          .finally(e=>{
          this.setSpinnerStatus(false);
          this.$bvModal.hide('modal-new');
        })
      }
    },
    search() {
      this.setLastSearch(this.search) 
      this.setSpinnerStatus(true);
      var params = {
            optGroup: this.getCurLabelGroup, modelName: this.getCurModel, language: this.getCurLanguage, 
            page: this.currentPage - 1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc, 
            label: this.labelFilter, code: this.codeFilter }
      
      this.axios
      .get('/ccb/auth/fe/callToAction/allPaged' ,  {
        params: params,
        ...this.authHeader}          
          )
          .then((response) => {
            window.datas = response.data;
            this.setSpinnerStatus(false);
            this.setCallToActionList(response.data.content)   
            this.totalRowsResult=response.data.totalElements;                  
          });
    }, 
    getCountries(){
      this.setSpinnerStatus(true);
      if (this.countryListNoDef.length == 0) {
        this.axios
        .get('/ccb/auth/fe/country/listNoDefault' ,  {
          params: null,
          ...this.authHeader}          
            )
            .then((response) => {
              this.setSpinnerStatus(false);               
              this.countryListNoDef = response.data.content; 
              window.countryListNoDef = this.countryListNoDef;
              this.getCountryCta();
            });
      } else {
        this.getCountryCta();
      }
    },
    getCountryCta(){
      this.setSpinnerStatus(true);
      this.axios
      .get('/ccb/auth/fe/countryCallToAction/get/'+this.curItem.id ,  {
        params: null,
        ...this.authHeader}          
          )
          .then((response) => {
            this.setSpinnerStatus(false);
            window.countryCtaListNoDefRaw = response.data;            
            this.countryCtaListNoDefRaw = response.data;
            this.mergeCountryCTA()
          });
    },
    mergeCountryCTA(){
      this.countryCtaListMerged = [];
      this.countryListNoDef.forEach(element => {
        var countryDescription = this.getCountryDescriptionByLang(element, this.getCurLanguage);
        var tmpCountry = this.countryCtaListNoDefRaw.find(c=>c.countryId == element.id);
        var ccta = {id: null, countryId:element.id, description: countryDescription, enable: false, callToActionId: this.curItem.id, modelEnableRegexp: "", modelDisableRegexp: ""}
        //console.log(ccta)
        if (tmpCountry!=null){
          ccta = {id: tmpCountry.id, countryId:tmpCountry.countryId, description: countryDescription, enable: tmpCountry.enable, callToActionId: tmpCountry.callToActionId, modelEnableRegexp: tmpCountry.modelEnableRegexp, modelDisableRegexp: tmpCountry.modelDisableRegexp, relevant: tmpCountry.relevant}
        }
        this.countryCtaListMerged.push(ccta);
      });
      this.countryCtaListMerged.sort((c1,c2) => c1.countryId > c2.countryId)
      //console.log(this.countryCtaListMerged);
      this.$bvModal.show('modal-edit')
    },
    getCountryDescriptionByLang(item,curLanguage){
        var label = 'descEn'
        Object.keys(item).forEach((key)=>{
          var bapp = curLanguage.toUpperCase()
          var bln = curLanguage.length
          var aLan = key.substr(bln*-1).toUpperCase()
       
          if(aLan == bapp)
              label = key 
        }) 
        return item[label]
    },
    btnNew() {},
    refreshTable() {
      this.search();
    },
    isActive (menuItem) {
      return this.activeEditCtaTab === menuItem
    },
    setActive (menuItem) {
      this.activeEditCtaTab = menuItem
    },
    ...mapActions([
      'setCurApp',      
      'setLastSearch',
      'setSpinnerStatus',
      'setInterfaceLabels',
      'setCurLabelGroup',
      'setCallToActionList'
      
    ]),
    scrollXPage (target, direction) {
      if(direction > 0) 
        this.$el.querySelector(target).parentNode.scrollLeft += this.$el.querySelector(target).clientWidth/4
      else
        this.$el.querySelector(target).parentNode.scrollLeft -= this.$el.querySelector(target).clientWidth/4
    }
  },
  props: ['action','activeGroup'],
  data () {
    return {
      countryListNoDef:[],
      countryCtaListNoDefRaw:[],
      countryCtaListMerged:[],
      activeEditCtaTab: 'textFields',
      totalRowsResult: 0,
      routerParams: null,
      currentPage:1,
      perPage:10,
      curItem: null,
      sortBy:'code',
      sortDesc: false,
      curItem:null,
      newItem : {id:null, language: null,  labelGroup: null, code : null ,label: null ,modelEnableRegexp: 'DEFAULT' , modelDisableRegexp: null, descriptionKey: null, sortNumber: null},
    country_fields: [
      {
        key: 'countryId',
        label: 'Country Id',
      },
      {
        key: 'description',
        label: 'Description'
      },
      {
        key: 'cta_checkbox',
        label: 'active cta code'
      },
      {
        key: 'cta_relevant_checkbox',
        label: 'relevant'
      },
      {
        key : 'model_enable',
        label: 'modelEnableRegexp'
      },
      {
        key : 'model_disable',
        label: 'modelDisableRegexp'
      },
      {
        key : 'save_button',
        label: 'salva'
      }
    ],
     fields: [
        {
          key: 'buttons',
          label: '',
          sortable: false
        },
        {
          key: 'code',
          //label: 'code',
          sortable: false
        },
        {
          key: 'labelCode',
          label: 'Label (IntLabel code)',
          sortable: false
        },
        {
          key: 'linkCode',
          label: 'Link (IntLabel code)',
          sortable: false
        },  
                {
          key: 'stKey',
          label: 'ST key',
          sortable: false
        }, 
                {
          key: 'adobeKey',
          label: 'Adobe key',
          sortable: false
        }, 
                {
          key: 'iconKey',
          label: 'Icon key',
          sortable: false
        },
        {
          key: 'descriptionKey',
          label: 'Description key',
          sortable: false
        },
        {
          key: 'sortNumber',
          label: 'Sort number',
          sortable: false
        }      
        
      ],
      labelFilter: '',
      codeFilter: ''
    }
  },
  computed: {
    items () {
      return (this.getCallToActionList && this.getCallToActionList.length) ? this.getCallToActionList : [];
    },
    ...mapState([
      'curLanguage',
      'curModel',      
      'languages',
      'models'
    ]),
    ...mapGetters([
      'getCurModel7DigitsCode',
      'getLanguageLabel',
      'getInterfaceLabels',
      'getLabelGroupList',
      'getCallToActionList',
      'authHeader',
      'getCurLabelGroup',
      'getCurLanguage',
      'getCurLanguageObj',
      'getCurModel'
    ])
  },
   watch: {
    $route (to,from){
      this.routerParams = to;
      if(to.query.activeGroup && to.query.activeGroup !=null){
        this.setCurLabelGroup(to.query.activeGroup);        
      }
      if(to.query.action && to.query.action === 'search'){
        // alert('search')
        this.search();    
      }
    },
    items (oldValue, newValue) {
      //console.log(this.$refs)
      this.$refs.call_to_action_tab.refresh();
    },
    currentPage(newValue,oldValue){
      this.refreshTable();
    },
    perPage(newValue,oldValue){
      this.refreshTable();
    },
    sortBy(newValue,oldValue){
      this.refreshTable();
    },
    sortDesc(newValue,oldValue){
      this.refreshTable();
    }
  },
  mounted() {
    window.scoper = this     
    this.search();    
    this.setCurApp('ccadm');
    this.$el.querySelector("#overflow_nav_buttons").style.cssText = "-ms-grid-rows: (1fr)[7]; -ms-grid-columns: (1fr)[12];"
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}

#overflow_nav_buttons {
	display: grid;
  display: -ms-grid;
	grid-template-rows: repeat(7,1fr);
	grid-template-columns: repeat(12,1fr);
	/* border: 2px blue solid; */
	width: calc(100% - 255px);
	height: 80vh;
	position: fixed;
	right: 0vw;
  bottom: 0px;
	font-size: 1.5em;
  pointer-events: none;
  opacity: 1;
  transition: 300ms ease-in-out;
}


#overflow_nav_buttons > #left_b {
	grid-row-start: 4;
	grid-row-end: 5;
	grid-column-start: 1;
	grid-column-end: 2;
  -ms-grid-row: 5;
	-ms-grid-column: 1;
	display: table;
  margin: auto;
	margin-left: 0vw;
  margin-bottom: 0vw;
  pointer-events: auto;
  cursor: pointer;
}

#overflow_nav_buttons > #left_b:hover {
  animation: pulse 1000ms ease-in 50ms infinite normal both;
}

#overflow_nav_buttons > #right_b:hover { 
  animation: pulse 1000ms ease-in 50ms infinite normal both;
}

#overflow_nav_buttons > #right_b {
	grid-row-start: 4;
	grid-row-end: 5;
	grid-column-start: 12;
	grid-column-end: 13;
  -ms-grid-row: 5;
	-ms-grid-column: 13;
	display: table; 
	margin: auto;
	margin-right: 0vw;
  margin-bottom: 0vw;
  pointer-events: auto;
  cursor: pointer;
}

.ovf_nav_btn_l {
  border-radius: 3px;
  text-shadow: 1px 1px 0px #999da2;
  transform: scale(1.5);
  animation: enter-left 500ms ease-in-out 500ms 1 normal both;
}

.ovf_nav_btn_r {
  border-radius: 3px;
  text-shadow: -1px 1px 0px #999da2;
  transform: scale(1.5);
  animation: enter-right 500ms ease-in-out 500ms 1 normal both;
}

@keyframes pulse {
  0% {
     color: #0c2340;
     text-shadow: -2px -2px 0px #f2f1f0, -1px 0px 0px #f2f1f0, -3px -3px 3px #f2f1f0;
  }
  50% {
     color: #f2f1f0;
     text-shadow: -2px -2px 0px #0c2340, -1px 0px 0px #0c2340, -3px -3px 3px #0c2340;
  }
  100% {
     color: #0c2340;
     text-shadow: -2px -2px 0px #f2f1f0, -1px 0px 0px #f2f1f0, -3px -3px 3px #f2f1f0;
  }
}

@keyframes enter-left {
  0% {
    opacity: 0;
    transform: translateX(-2vw) scale(0);
  }
  100% {
    opacity: 1;
    transform: translateX(0vw) scale(1.5);
  }
}

@keyframes enter-right {
  0% {
    opacity: 0;
    transform: translateX(2vw) scale(0);
  }
  100% {
    opacity: 1;
    transform: translateX(0vw) scale(1.5);
  }
}

@media screen and (max-width:990px ){
  #overflow_nav_buttons { 
    width: 96vw;
  }
}

</style>
